import {
    InMessageTopic,
    SanitisesPayload,
} from 'embedded/api/in/InMessageTopic';
import {
    SetOrderIdsMessagePayload,
    setOrderIdsPayloadSchema,
} from 'embedded/api/in/messages/SetOrderIdsMessagePayload';
import { Store } from 'redux';
import { LoggingService } from '@instinet-analytics/core-lib';
import { embeddedAppStateActions } from 'embedded/store/embeddedAppStateSlice';

export class SetOrderIdsMessage
    extends InMessageTopic<SetOrderIdsMessagePayload>
    implements SanitisesPayload<SetOrderIdsMessagePayload>
{
    public constructor() {
        super(setOrderIdsPayloadSchema);
    }

    public handle(
        uid: string,
        payload: SetOrderIdsMessagePayload,
        store: Store,
        _loggingService: LoggingService
    ): void {
        const { orderIds } = payload;
        store.dispatch(
            embeddedAppStateActions.setOrderIds({
                orderIds: orderIds,
                source: 'EmbeddedApi',
            })
        );
    }

    public sanitizePayload(payload?: SetOrderIdsMessagePayload) {
        return {
            count: payload?.orderIds.length ?? 0,
            firstOrderId:
                (payload?.orderIds ?? []).length > 0
                    ? payload?.orderIds[0]
                    : '',
        };
    }
}
